import React from 'react';
import bemHelper from 'react-bem-helper';

import { replaceStyleImageUri, formatDate } from '../../utils';
import * as constants from '../../constants';
import Rating from '../RatingModule/RatingModule';

import './styles.scss';

const bem = bemHelper({ prefix: 'toga-', name: 'storefront-intro' });

class IntroModule extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      width: 0
    };
  }

  updateDimensions() {
    const windowWidth = document && document.body.clientWidth;

    this.setState({
      width: windowWidth
    });
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions.bind(this));
  }

  render() {
    const { logo, cover, partnerName, rating, totalReviews, since, introAltText } = this.props;
    return (
      <div {...bem()}>
        <div {...bem('wrapper')}>
          <div {...bem('banner-shadow')}></div>
          <div {...bem('section-logo')}>
            <figure {...bem('logo')}>
              <img
                srcSet={`${replaceStyleImageUri(logo.url, constants.IMAGE_SIZE_NORMAL)}, ${replaceStyleImageUri(logo.url, constants.IMAGE_SIZE_RETINA)} 2x`}
                src={logo && replaceStyleImageUri(logo.url, constants.IMAGE_SIZE_NORMAL)}
                alt={introAltText}/>
            </figure>

            <article {...bem('info-container')}>
              <h1 {...bem('maintitle')}>
                {partnerName}
              </h1>
              <h4 {...bem('information')}>
                {since && `Since ${formatDate(since, constants.PARTNER_JOINED_FORMAT)}`}
                {since && <span {...bem('separator')}> / </span>}
                {totalReviews || 0} reviews
              </h4>
              <Rating {...bem('rating')} rating={+rating}/>
              <div className="sr-only">This partner has a rating of {rating} stars</div>
            </article>
          </div>

          <figure {...bem('banner')}>
            <img src={cover && replaceStyleImageUri(cover.url, constants.IMAGE_SIZE_NORMAL)}
                 srcSet={`${replaceStyleImageUri(cover.url, constants.IMAGE_SIZE_NORMAL)}, ${replaceStyleImageUri(cover.url, constants.IMAGE_SIZE_RETINA)} 2x`}
                 alt={cover.altText}/>
          </figure>
        </div>
      </div>
    );
  }

}

export default IntroModule;



// WEBPACK FOOTER //
// ./src/components/storefront/components/IntroModule/IntroModule.js